import DragAndDrop from '@common-web/drag-and-drop';
import QuickLinkDNDitems from '../quick-link-dnd-items';

const ManageModalBody = ({ links = [], setLinks }) => {
  const setLinksInOrder = (links) => {
    setLinks(links);
  };

  const dndItems = links.map((link) => {
    return {
      id: link.id,
      content: <QuickLinkDNDitems currentLink={link} deleteEnabled={true} quickLinks={links} />,
    };
  });

  return <DragAndDrop dragItems={dndItems} itemOrder={links} setItemOrder={setLinksInOrder} />;
};

export default ManageModalBody;
